import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Item, ReportService, translation_config} from '../../../service/report.service'
import { NotifierService } from 'angular-notifier';
import {InsightApiService} from '../../../../shared/insights/service/insight-api.service';
import  {  FormGroup,  FormControl,  Validators}  from  '@angular/forms';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { typeUploadFileDropdown } from 'src/app/repository/service/types';



@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit, AfterViewInit, OnDestroy {
  public fileSelected:string ="";
  public acceptableExtentions:string;
  public uuid = this.router.snapshot.params.uuid;
  public fileObj:any;
  public item:Item;
  public languages:any;
  public audiotranlanguages:any;
  public translationLanguages: { name: string, value: string }[] = [];
  public translationUploadTypes: { name: string, value: string }[] = [];
  public zipOperations: { name: string, value: string }[] = [
    { name: "Survey Response Image to Text", value: "survey_to_text_zip" },
    { name: "None(Upload Only)", value: "none" },
  ];
  // public isCheckedAnalyseVideo:boolean = false;
  public uploadRequest = new FormGroup({
    file_type: new FormControl(''),
    value: new FormControl(" ")
  })
  public singleFileValue:any;
  private fileUploadPogressEvent: Subscription;
  public fileUploadPogress:any = 0;
  public percent = 0;
  public isTranslationUpload: boolean = false;
  public translateConfigKeyValue:any = {};
  public defaultTranslateCustomHeaderValue:any = {};
  public job_id:string = "";
  public objective:string = "";
  public localDefaultMatSelectFile: typeUploadFileDropdown = null;
  public audiotranslatoracceptableExtentions:string = ".mp3,.MP3,.m4a,.M4A,.wav,.WAV";
  public isAdvanceSetting:boolean = true;
  // public item:any = [];
  @ViewChild("progressBar") progressBar: ElementRef;
  @ViewChild('scrollableDiv') scrollableDiv: ElementRef;

  constructor(
    public RService:ReportService,
    public router: ActivatedRoute,
    public notify:NotifierService,
    public insightApi:InsightApiService,
  ) {

    this.fileUploadPogressEvent = this.RService.emitFileUploadPogress.subscribe((uploadState)=>{
      if(this.RService.isFullRequestFileComponent){
        this.fileUploadPogress = uploadState.progress;
        if (this.progressBar) {
          this.percent = this.fileUploadPogress > this.percent ? this.fileUploadPogress : this.percent;
          this.progressBar.nativeElement.style.width = this.percent+"%";
        }

      }
    });

    this.localDefaultMatSelectFile = JSON.parse(JSON.stringify(this.RService.defaultMatSelectFile));
    Object.keys(this.localDefaultMatSelectFile.translateConfig.customHeaders[0]).forEach((k, i)=> { 
      this.translateConfigKeyValue[i] = k;
      this.defaultTranslateCustomHeaderValue[k] = "";
    });
   }
  ngOnDestroy(): void {
    if (this.fileUploadPogressEvent) {
      this.fileUploadPogressEvent.unsubscribe();
    }
    this.percent = 0;
    this.fileUploadPogress = 0;
    this.RService.showPogress = false;
    this.job_id = "";
    this.objective = "";
    this.RService.replaceFileObj = {};

  }
  ngAfterViewInit(): void {
    // this.progressBar.nativeElement.style.width = this.fileUploadPogress+"%";
  }

  ngOnInit(): void {
    this.RService.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.getLanguages();
    this.getTranslationUploadConfig();
    this.audiotranlanguages = [{"name":"Hindi","value":"hi-IN"},{"name":"Gujarati","value":"gu-IN"},{"name":"Kannada","value":"kn-IN"},{"name":"Malayalam","value":"ml-IN"},{"name":"Tamil","value":"ta-IN"},{"name":"Telugu","value":"te-IN"}];
    // this.languages = [{"name":"Gujarati","value":"gu-IN"},{"name":"Hindi","value":"hi-IN"},{"name":"Kannada","value":"kn-IN"},{"name":"Malayalam","value":"ml-IN"},{"name":"Tamil","value":"ta-IN"},{"name":"Telugu","value":"te-IN"}];
  }
  CloseUploadPanel = () =>
  {
    this.RService.CloseUploadPanel();
  }
  AddIncrement = (ind:any) =>
  {
    if(!this.RService.MatSelectFileArray[ind]['file_type'])
    {
        this.notify.notify('error','Please fill file type ');
    }
    else if(!this.RService.MatSelectFileArray[ind]['value'])
    {
      this.notify.notify('error','Please select the file');
    }
    else
    {
      this.RService.MatSelectFileArray.push(JSON.parse(JSON.stringify(this.localDefaultMatSelectFile)));
    }
    this.scrollToBottom();
  }
  RemoveIncrement = (n:number) =>
  {
    if(n == 0)
    {
      this.RService.MatSelectFileArray.splice(n,1);
      if(this.RService.MatSelectFileArray.length == 0)
      {
        this.RService.replaceFileObj = {};
        this.RService.MatSelectFileArray.push(JSON.parse(JSON.stringify(this.localDefaultMatSelectFile)));
      }
    }
    else
    {
      this.RService.MatSelectFileArray.splice(n,1);
    }
    this.RService.uploadMultipleFileContainer.splice(n,1);
    // this.RService.uploadFileContainer.splice(n,1);
    
  }
  uploadFile = (event:Event,ind:number) =>
  {
    // if(this.RService.isFullFileUploadComponent == 'external'){
    //   const target = event.target;
    //   const uploadedFileSize = target['files'] && target['files'][0] && target['files'][0].size || 0;
    //   if(uploadedFileSize <= this.RService.externalFileUploadMaxAllowedSize){
    //     this.acceptFileUpload(event, ind);
    //   }
    //   else{
    //     this.notify.notify('error',"Can't upload file larger than 200MB");
    //   }
    // }
    // else{
    //   this.acceptFileUpload(event, ind);
    // }
      const target = event.target;
      const uploadedFileSize = target['files'] && target['files'][0] && target['files'][0].size || 0;
      if(uploadedFileSize <= this.RService.externalFileUploadMaxAllowedSize){
        this.acceptFileUpload(event, ind);
      }
      else{
        this.notify.notify('error',"Can't upload file larger than 200MB");
      }
    
  }

  onSelectFileType(ind) {
    this.acceptableExtentions = "";
    this.assignFileExtention(this.RService.MatSelectFileArray[ind]['file_type']);
    this.handleTranslationUpload();
  }
  
  handleTranslationUpload() {
    this.isTranslationUpload = this.RService.MatSelectFileArray.some(f=> f.file_type == 'Translation');
    this.RService.translateFileUploadedEvent.emit(this.isTranslationUpload);
  }

  convertXlsxToJSON = (fileIdx: number) => {
    let currFileSet = this.RService.MatSelectFileArray[fileIdx];
    if (currFileSet && currFileSet.value.length > 0) {
      const file: any = currFileSet.value[0];
      
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const arrayBuffer = e.target?.result as ArrayBuffer;
        const data = new Uint8Array(arrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        let headers = jsonData[0] as string[];
        headers = headers.map(h=> h.trim());
        this.RService.MatSelectFileArray[fileIdx].translateConfig.headers = headers;
        this.localDefaultMatSelectFile.translateConfig.headers = headers;
        this.setCustomHeaderDefaults(fileIdx);
      };
      reader.readAsArrayBuffer(file);
    }
  }


  acceptFileUpload(event: Event, ind:number){
      // this.acceptableExtentions = "";
      // this.assignFileExtention(this.RService.MatSelectFileArray[ind]['file_type']);
      if(this.acceptableExtentions)
      {
        const target = event.target as HTMLInputElement;
        this.fileObj = target.files as FileList;
        this.RService.MatSelectFileArray[ind]['value'] = this.fileObj;
        if(this.isTranslationUpload) {
          this.convertXlsxToJSON(ind);
        }
        let fileArr = Array.from(this.fileObj);
        let fileContainer = [];
        fileArr.forEach(element => {
          this.item  = {
            fileObj:element,
            file_type:this.RService.MatSelectFileArray[ind]['file_type'],
            vi_index:this.RService.MatSelectFileArray[ind]['vi_index'],
            language:this.RService.MatSelectFileArray[ind]['language'],
            isAudiotranslator:this.RService.MatSelectFileArray[ind]['isAudiotranslator'] || false,
            translate_numeric:this.RService.MatSelectFileArray[ind]['translate_numeric'] || false,
            translate_numeric_to_numeric:this.RService.MatSelectFileArray[ind]['translate_numeric_to_numeric'] || false,
            audiotranslation_config:this.RService.MatSelectFileArray[ind]['audiotranslation_config'] || null,
            translator_lang:this.RService.MatSelectFileArray[ind]['translator_lang'] || null,
            fileName:this.getFileName(element['name']),
            zip_file_operation: this.RService.MatSelectFileArray[ind]['file_type'] == 'Zip' && this.RService.MatSelectFileArray[ind]['zipConfig']['operation'] ? this.RService.MatSelectFileArray[ind]['zipConfig']['operation'] : false
          };
          fileContainer.push(this.item);
          // this.RService.uploadFileContainer.push(this.item);
        });
        this.RService.uploadMultipleFileContainer.push(fileContainer);
      }
      else
      {
        this.notify.notify('error','Please select correct file format');
      }
  }
  getFileName(url){
    return url.replace(/^.*(\\|\/|\:)/, '');
  }
  getFileTypeArr(Var:any){
    return Var.map(ob=>{

      if(ob.file_type == 'Data Table - ABS'){
        return 'dataTable-abs';
      }
      else if(ob.file_type == 'Data Table - PCT'){
        return 'dataTable-pct';
      }else if(ob.file_type == 'Report - KPI View'){
        return 'kpiViewer';
      }
      else{
        return ob.file_type.toLowerCase();
      }
    });
  }
  assignFileExtention(v:string){
    switch(v){
      case "Report" : this.acceptableExtentions = ".pdf,.docx,.pptx,.txt,.csv,.xlsx,.doc";
      break;
      case "Questionnaire" : this.acceptableExtentions = ".pdf,.docx,.pptx,.txt,.csv,.xlsx,.doc";
      break;
      case "Data Table - ABS" : this.acceptableExtentions = ".pptx,.csv,.xlsx,.doc,.docx";
      break;
      case "Data Table - PCT" : this.acceptableExtentions = ".pptx,.csv,.xlsx,.doc,.docx";
      break;
      case "Report - KPI View" : this.acceptableExtentions = ".csv,.xlsx";
      break;
      case "Image" : this.acceptableExtentions = ".png,.jpg,.jpeg";
      break;
      case "Video" : this.acceptableExtentions = ".3gp,.mp4,.MP4,.MOV,.AVI,.MKV,.3GP";
      break;
      case "Audio" : this.acceptableExtentions = ".mp3,.MP3,.m4a,.M4A,.wav,.WAV";
      break;
      case "Zip" : this.acceptableExtentions = ".zip,.rar,.7zip";
      break;
      case "Translation" : this.acceptableExtentions = ".xlsx";
      break;
    }
  }
  ConvertValue = (value:any,length?) =>
  {
    let arr = Array.from(value);
    let str = "";
    if(arr.length){
      arr.forEach(ele =>{
        str += ele['name'];
      })
    }
    return length && length > 0 ? str.substring(0,length) +"..." :  str;
    // return isFullNameShow ? str :str.substring(0,20);
  }
  // acceptType = (val:any,event:Event) =>
  // {
  //   const target = event.target as HTMLInputElement;
  //   this.fileObj = target.files as FileList;
  //   this.singleFileValue = this.fileObj[0]['name'];
  //   let v1 = this.singleFileValue.split('.')[1].toLowerCase();
  //   let v2 = val.toLowerCase();
  //   return v2.includes(v1);

  // }

  selectAnalyseVideo(fileItemIndex){
    // this.isCheckedAnalyseVideo;
    this.RService.MatSelectFileArray[fileItemIndex]['vi_index'] = !this.RService.MatSelectFileArray[fileItemIndex]['vi_index']
    if (this.RService.uploadMultipleFileContainer && this.RService.uploadMultipleFileContainer[fileItemIndex]  && this.RService.uploadMultipleFileContainer[fileItemIndex] != undefined) {
      this.RService.uploadMultipleFileContainer[fileItemIndex][0]['vi_index'] = this.RService.MatSelectFileArray[fileItemIndex]['vi_index'];
    }
  }


  selectTranslateNumeric(ind,type){
    if(type == 'numberToWords'){
      this.selectTranslateNumericText(ind);
      this.RService.MatSelectFileArray[ind]['translate_numeric_to_numeric'] = false;
      this.RService.uploadMultipleFileContainer[ind][0]['translate_numeric_to_numeric'] = false;
    }else{
      this.selectTranslateNumericToNumeric(ind);
      this.RService.MatSelectFileArray[ind]['translate_numeric'] = false;
      this.RService.uploadMultipleFileContainer[ind][0]['translate_numeric'] = false;
    }
  }

  selectTranslateNumericText(fileItemIndex){
    // this.isCheckedAnalyseVideo;

    this.RService.MatSelectFileArray[fileItemIndex]['translate_numeric'] = !this.RService.MatSelectFileArray[fileItemIndex]['translate_numeric']
    if (this.RService.uploadMultipleFileContainer && this.RService.uploadMultipleFileContainer[fileItemIndex]  && this.RService.uploadMultipleFileContainer[fileItemIndex] != undefined) {
      this.RService.uploadMultipleFileContainer[fileItemIndex][0]['translate_numeric'] = this.RService.MatSelectFileArray[fileItemIndex]['translate_numeric'];
    }
  }

   selectTranslateNumericToNumeric(fileItemIndex){
    // this.isCheckedAnalyseVideo;
    this.RService.MatSelectFileArray[fileItemIndex]['translate_numeric_to_numeric'] = !this.RService.MatSelectFileArray[fileItemIndex]['translate_numeric_to_numeric']
    if (this.RService.uploadMultipleFileContainer && this.RService.uploadMultipleFileContainer[fileItemIndex]  && this.RService.uploadMultipleFileContainer[fileItemIndex] != undefined) {
      this.RService.uploadMultipleFileContainer[fileItemIndex][0]['translate_numeric_to_numeric'] = this.RService.MatSelectFileArray[fileItemIndex]['translate_numeric_to_numeric'];
    }
  }

  selectAudioTranslationLanguage(ind){
    this.RService.MatSelectFileArray[ind]['isAudiotranslator'] = !this.RService.MatSelectFileArray[ind]['isAudiotranslator'];
    if (this.RService.MatSelectFileArray[ind]['isAudiotranslator']) {
      this.RService.MatSelectFileArray[ind]['audiotranslation_config'] = {
        fileObj: null,
        translator_lang:'',
        file_name: ''
      } 

    } 
    if (this.RService.uploadMultipleFileContainer && this.RService.uploadMultipleFileContainer[ind]  && this.RService.uploadMultipleFileContainer[ind] != undefined) {
      this.RService.uploadMultipleFileContainer[ind][0]['isAudiotranslator'] = this.RService.MatSelectFileArray[ind]['isAudiotranslator'];
    }
  }
  onLanguageChange(fileItemIndex){
    if (this.RService.uploadMultipleFileContainer && this.RService.uploadMultipleFileContainer[fileItemIndex]  && this.RService.uploadMultipleFileContainer[fileItemIndex] != undefined) {
      this.RService.uploadMultipleFileContainer[fileItemIndex][0]['language'] = this.RService.MatSelectFileArray[fileItemIndex]['language'];
    }
  }

  

  selectAudioTranslationFile(event:any,ind:number){
    const target = event.target;
    const uploadedFileSize = target['files'] && target['files'][0] && target['files'][0].size || 0;
    const files = target.files;

   


    if(uploadedFileSize <= this.RService.externalFileUploadMaxAllowedSize){
      if(files.length){
        this.RService.MatSelectFileArray[ind]['audiotranslation_config']['fileObj'] = target['files'][0];
        this.RService.MatSelectFileArray[ind]['audiotranslation_config']['file_name'] = target['files'][0]['name'];
      }
    }
    else{
      this.notify.notify('error',"Can't upload file larger than 200MB");
    }

  }

  uploadFileFunc = (i:number) =>
  {
    if(this.RService.MatSelectFileArray[i]['file_type'] == 'Translation' && (!this.RService.MatSelectFileArray[i]['translateConfig'].currType || this.RService.MatSelectFileArray[i]['translateConfig'].currType ==''))
      {
        this.notify.notify('error','Please select file format.');
        this.RService.isUploadFileInput = false;
      }else if(this.RService.MatSelectFileArray[i]['file_type'] == 'Zip' && this.checkSurveyTranslationAccess(this.RService.MatSelectFileArray[i]['file_type']) && (!this.RService.MatSelectFileArray[i]['zipConfig'].operation || this.RService.MatSelectFileArray[i]['zipConfig'].operation ==''))
      {
        this.notify.notify('error','Please select operation.');
        this.RService.isUploadFileInput = false;
      }else if(this.RService.MatSelectFileArray[i]['file_type'])
    {
      this.RService.isUploadFileInput = true
    }else
    {
      this.notify.notify('error','Please select file type.');
      this.RService.isUploadFileInput = false;
    }
  }
  UploadFileSubmit = () =>
  {
    if(this.checkForObjective()){
      const objective = this.objective;
      const objective_word_len = objective.split(" ").length || 0;
      if(!objective || objective_word_len < 15){
        this.notify.notify('error','Please enter objective in detail and more than 15 words.');
        return;
      }
    }

    if(this.checkForJobId()){
      const jobId = this.job_id;
      if(!(jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 10 || jobId && /^[\d-]+$/.test(jobId) && jobId.replace(/-/g, '').length === 12)){
        this.notify.notify('error','Please enter correct 10 or 12 digit Job ID');
        return;
      }
    }

   
    if (this.RService.showPogress) {
      this.notify.notify('warning','Please wait while the file is being uploaded.');
    }else{
      let uuid = this.uuid;
      if(this.RService.isFullFileUploadComponent=='external'){
        uuid = this.RService.externalFileUploadToken;
      }
      // let file_type = this.getFileTypeArr(this.RService.uploadMultipleFileContainer);
      let checkTranslationUploadValidation = this.setTranslationFileConf();
      if(!checkTranslationUploadValidation) return;

      let checkTranslationAudioUploadValidation = this.checkForTranslationAudioUploadValidation();
      if(!checkTranslationAudioUploadValidation) return;
       this.RService.uploadFileContainer = [];
      this.RService.uploadFileContainer = [].concat.apply([],this.RService.uploadMultipleFileContainer);
      // console.log('this.RService.uploadFileContainer',this.RService.uploadFileContainer);
      this.RService.uploadMultipleFileContainer = [];
      let cond = {'job_id':this.job_id,'objective':this.objective};
      this.RService.uploadMultipleFile(uuid,cond);
      // console.log('this.RService.uploadFileContainer',this.RService.uploadFileContainer);
    }
  }


  checkForTranslationAudioUploadValidation():boolean{

    for(let i=0; i<this.RService.uploadMultipleFileContainer.length; i++){
      let audiotranslation_config = this.RService.MatSelectFileArray[i]['audiotranslation_config'];
      let isAudiotranslator = this.RService.MatSelectFileArray[i]['isAudiotranslator'];
      if(isAudiotranslator){
        let orignal_video_lang = this.RService.MatSelectFileArray[i]['language'];
        if(!orignal_video_lang || orignal_video_lang == ''){
          this.notify.notify('error','Please select original video language.');
          return false;
        }
        if(!audiotranslation_config.fileObj || audiotranslation_config.fileObj == null){
          this.notify.notify('error','Please select audio translation file.');
          return false;
        }
        if(!audiotranslation_config.translator_lang || audiotranslation_config.translator_lang == ''){
          this.notify.notify('error','Please select audio translation language.');
          return false;
        }
        this.RService.uploadMultipleFileContainer[i][0]['isAudiotranslator'] = isAudiotranslator;
        this.RService.uploadMultipleFileContainer[i][0]['audiotranslation_config'] = audiotranslation_config;
        this.RService.uploadMultipleFileContainer[i][0]['translator_lang'] = audiotranslation_config.translator_lang;
        this.RService.uploadMultipleFileContainer[i][0]['language'] = orignal_video_lang;
      }
    }
    // console.log('this.RService.uploadMultipleFileContainer',this.RService.uploadMultipleFileContainer);
    return true;

  }

  setTranslationFileConf() {
    let isValid = true;
    for(let i=0; i<this.RService.uploadMultipleFileContainer.length; i++){
      let tConf: translation_config = {
        type: this.RService.MatSelectFileArray[i]['translateConfig'].currType,
        languageColumnMap: this.RService.MatSelectFileArray[i]['translateConfig'].customHeaders && this.RService.MatSelectFileArray[i]['translateConfig'].customHeaders.length > 0 ? this.RService.MatSelectFileArray[i]['translateConfig'].customHeaders : null,
      }


      // if(!tConf.type) {
      //   this.notify.notify('error','Please select translation file type.');
      //   isValid = false;
      //   break;
      // }

      let fileArr = this.RService.uploadMultipleFileContainer[i];
      for(let j=0; j<fileArr.length; j++) {
        let file = fileArr[j];
        if(file.file_type == 'Translation'){
          if(!tConf.type) {
            this.notify.notify('error','Please select translation file format.');
            isValid = false;
            break;
          }
          if(tConf.type == 'custom'){
            if(!tConf.languageColumnMap) {
              this.notify.notify('error','Please select all the custom headers for translation file.');
              isValid = false;
              break;
            }

            const destinations = tConf.languageColumnMap.map(l => l.destination);
            const uniqueDestinations = new Set(destinations);
            if (uniqueDestinations.size !== destinations.length) {
              this.notify.notify('error','Duplicate destination values found in destiny column.');
              isValid = false;
              break;
            }

            const langs = tConf.languageColumnMap.map(l => l.langCode);
            const uniqueLangs = new Set(langs);
            if (uniqueLangs.size !== langs.length) {
              this.notify.notify('error','Duplicate Language values found in Language column.');
              isValid = false;
              break;
            }
          } else {
            tConf.languageColumnMap = null;
          }
          this.RService.uploadMultipleFileContainer[i][j].translation_config = tConf;
        }
      }
    }
    return isValid;
  }

  getLanguages(){
    this.RService.getLanguages().subscribe(data => {
      if(data['status'] == 1){
        this.languages = data['languages'] 
      }else{
        this.notify.notify("error",'Something went wrong!');
      }
    });
  }

  onSelectTranslationType(ind: number, event: any) {
    this.RService.MatSelectFileArray[ind]['translateConfig']['currType'] = event.value;
    this.RService.MatSelectFileArray[ind]['translateConfig']['customHeaders'] = [JSON.parse(JSON.stringify(this.defaultTranslateCustomHeaderValue))];
    if(event.value == "custom"){
      this.setCustomHeaderDefaults(ind);
    }
  }

  onSelectZipOperation(ind: number, event: any) {
    this.RService.MatSelectFileArray[ind]['zipConfig']['operation'] = event.value;
  }

  setCustomHeaderDefaults(ind: number) {
    Object.keys(this.localDefaultMatSelectFile.translateConfig.customHeaders[0]).forEach((k, i)=> {
      if(k == "langCode") {
        this.localDefaultMatSelectFile.translateConfig.customHeaders[0][k] = this.translationLanguages[0].value;
      } else {
        this.localDefaultMatSelectFile.translateConfig.customHeaders[0][k] = this.localDefaultMatSelectFile.translateConfig.headers[0];
      }
      this.translateConfigKeyValue[i] = k;
      this.defaultTranslateCustomHeaderValue[k] = this.localDefaultMatSelectFile.translateConfig.customHeaders[0][k];
    });
    this.RService.MatSelectFileArray[ind]['translateConfig']['customHeaders'] = this.RService.MatSelectFileArray[ind]['translateConfig']['customHeaders'].map(h=> {
      Object.keys(this.defaultTranslateCustomHeaderValue).forEach(k=> {
        if(!h[k]) h[k] = this.defaultTranslateCustomHeaderValue[k];
      });
      return {...h};
    });
  }

  onSelectTranslationCustom(ind: number, idx: number, changeKey: string, value: string) {
    this.RService.MatSelectFileArray[ind]['translateConfig']['customHeaders'][idx][changeKey] = value;
  }

  getTranslationUploadConfig() {
    let query = this.RService.replaceFileObj ? this.RService.replaceFileObj : {}
    this.RService.getTranslationUploadConfig(query).subscribe(data => {
      if(data['status'] == 1) {
        this.translationLanguages = data['translationLanguages'];
        this.translationUploadTypes = data['uploadConfig'];
        if(data['zipConfig'] && data['zipConfig'].length > 0) {
          this.zipOperations = [{name: "None(Upload Only)", value: "none"}, ...data['zipConfig']];
        }
        if (data['file']) {
          data['file']['file_type'] = data['file']['file_type'] == "translation" ? "Translation" : data['file']['file_type'];
          data['file']['vi_index'] = false;
          // let  defaultMatSelectFile = {
          //       "file_type": "Translation",
          //       "value": "",
          //       "vi_index": false,
          //       "language": "",
          //       "fileName": "translation_test_faiz.xlsx",
          //       "translateConfig": {
          //         "currType": "custom",
          //         "headers": ["Full Object Name"],
          //         "customHeaders": [
          //           {
          //             "source": "Full Object Name",
          //             "destination": "Full Object Name",
          //             "langCode": "hi"
          //           }
          //         ]
          //       }
          //     }
              // this.RService.MatSelectFileArray = [JSON.parse(JSON.stringify(defaultMatSelectFile))];
              this.RService.MatSelectFileArray = [JSON.parse(JSON.stringify(data['file']))];
              this.onSelectFileType(0);
        }
      } else {
        this.notify.notify("error",'Something went wrong!');
      }
    });
  }

  addMoreCustomHeader(mainIdx: number){
    this.RService.MatSelectFileArray[mainIdx]['translateConfig']['customHeaders'].push(JSON.parse(JSON.stringify(this.defaultTranslateCustomHeaderValue)));
    this.scrollToBottom();
  }

  removeMoreCustomHeader(mainIdx: number, remIdx: number){
    this.RService.MatSelectFileArray[mainIdx]['translateConfig']['customHeaders'].splice(remIdx, 1);
  }
  
  checkForJobId(){
    let isAnalyseCheckon = this.RService.MatSelectFileArray.some((item:any) => item.vi_index || item.file_type == 'Translation');
    if(isAnalyseCheckon && !this.RService.reportDetails.job_id && this.RService.isFullFileUploadComponent=='yes'){
      return true;
    }
    return false;
  }

  checkForObjective(){
    let isAnalyseCheckon = this.RService.MatSelectFileArray.some((item:any) => item.vi_index);
    if(isAnalyseCheckon && !this.RService.reportDetails.objective && this.RService.isFullFileUploadComponent=='yes'){
      return true;
    }
    return false;
  }


  scrollToBottom(): void {
    setTimeout(() => {
      const div = this.scrollableDiv.nativeElement;
      const scrollHeight = div.scrollHeight;
      const clientHeight = div.clientHeight;
      const scrollTop = scrollHeight - clientHeight;
    
      // Create smooth scrolling with requestAnimationFrame
      const currentScroll = div.scrollTop;
      const distanceToScroll = scrollTop - currentScroll;
      const duration = 300; // Duration of the scroll in milliseconds
      let startTime: number = null;
    
      function animateScroll(time: number) {
        if (!startTime) startTime = time;
        const timeElapsed = time - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        div.scrollTop = currentScroll + distanceToScroll * progress;
    
        if (timeElapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      }
    
      requestAnimationFrame(animateScroll);
    }, 0);
  }

  checkSurveyTranslationAccess(file_type): boolean {
    let isValid = file_type == 'Zip' && this.RService.accessRoles && this.RService.accessRoles.access_rules && this.RService.accessRoles.access_rules.repository && this.RService.accessRoles.access_rules.repository.survey_translation ? true : false;
    return isValid;
  }



}
